/**
 * @internal
 */
export enum ParticleBillboardVertexAttribute {
  cornerTextureCoordinate = "a_CornerTextureCoordinate"
}
